import React from 'react';
import { TopProduct } from '../goalsTargetsTypes';
import styles from './TopProductsCard.module.css';

interface TopProductsCardProps {
  products: TopProduct[];
}

export const TopProductsCard: React.FC<TopProductsCardProps> = ({ products }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Top Performing Products</h3>
        <span className={styles.headerIcon}>$</span>
      </div>
      <div className={styles.list}>
        {products.map((p) => (
          <div key={p.id} className={styles.row}>
            <span className={styles.rank}>#{p.rank}</span>
            <div className={styles.info}>
              <p className={styles.name}>{p.name}</p>
              <p className={styles.orders}>{p.ordersCount}</p>
            </div>
            <div className={styles.right}>
              <p className={styles.revenue}>{p.revenue}</p>
              <p className={styles.growth}>{p.growth}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
